import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const VerifiedBadge = ({ size = 16, className = "" }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span data-testid="verified-badge" className={`inline-flex items-center justify-center cursor-help ${className}`}>
        <CheckCircle2
          size={size}
          className="text-white"
          style={{ fill: "#8012C6", filter: "drop-shadow(0 0 4px rgba(108,11,169,0.7))" }}
        />
      </span>
    </TooltipTrigger>
    <TooltipContent data-testid="verified-tooltip" className="max-w-[240px] text-xs leading-relaxed bg-popover text-popover-foreground border border-border">
      <div className="font-semibold mb-0.5">Verified member</div>
      This person supports Xealth with a Verified subscription. Email and phone checks are shown on their profile.
    </TooltipContent>
  </Tooltip>
);
